import { useState } from "react";
import { useI18n } from "../../../i18n/I18nContext";
import { api } from "../../api/axios";
import Footer from "../Footer/Footer";

export default function Contact() {
  const { t } = useI18n();
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    empresa: "",
    telefone: "",
    motivo: "",
    mensagem: "",
  });

  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setErrorMsg("");

    try {
      await api.post("/api/v1/contact", form);

      setSent(true);
      setForm({
        firstName: "",
        lastName: "",
        email: "",
        empresa: "",
        telefone: "",
        mensagem: "",
      });
    } catch (error) {
      if (error.response?.status === 429) {
        setErrorMsg("Demasiadas tentativas. Tenta novamente dentro de 1 minuto.");
      } else if (error.response?.data?.errors) {
        const firstError = Object.values(error.response.data.errors)[0]?.[0];
        setErrorMsg(firstError || "Ocorreu um erro ao enviar a mensagem.");
      } else if (error.response?.data?.error) {
        setErrorMsg(error.response.data.error);
      } else if (error.response?.data?.message) {
        setErrorMsg(error.response.data.message);
      } else {
        setErrorMsg("Ocorreu um erro ao enviar a mensagem.");
      }
    } finally {
      setSending(false);
    }
  };

  const contactInfo = [
    {
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
          />
        </svg>
      ),
      label: t("Telefone"),
      value: "+351 91 365 07 24",
      href: "tel:+351913650724",
    },
    {
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
          />
        </svg>
      ),
      label: t("Email"),
      value: "clients@racksforall.eu",
      href: "mailto:clients@racksforall.eu",
    },
    {
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
          />
        </svg>
      ),
      label: t("Morada"),
      value: t("Estrada Nacional 1, Edifício Sol, 37, 2ºA\n2440-489 Batalha, Portugal\n\nAzores Park - Pavilhão 2.1 - Praceta 2\nCaminho Velho do Pico da Pedra, 102\n9500-702 Ponta Delgada, Açores"),
      href: "https://maps.google.com/?q=Estrada+Nacional+1+Batalha+Portugal",
    },
    {
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
      label: t("Horário"),
      value: t("Segunda a Sexta, 9h00 – 18h00"),
      href: null,
    },
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <section className="bg-indigo-700 pt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 lg:py-20 text-center">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-indigo-200 mb-4 bg-white/10 px-3 py-1 rounded-full">
            {t("Fale connosco")}
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
            {t("Contactos")}
          </h1>
          <p className="text-indigo-100/80 max-w-xl mx-auto text-base">
            {t("Estamos disponíveis para responder a todas as suas questões sobre produtos, orçamentos e instalações.")}
          </p>
        </div>

        <div className="overflow-hidden leading-none">
          <svg
            viewBox="0 0 1440 60"
            className="w-full"
            preserveAspectRatio="none"
            style={{ height: 60 }}
          >
            <path
              d="M0,40 C360,80 1080,0 1440,40 L1440,60 L0,60 Z"
              fill="white"
            />
          </svg>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 gap-10 items-stretch">
            <div className="space-y-6">
              <div className="rounded-3xl border border-gray-200 bg-white shadow-md overflow-hidden">
                <div className="bg-indigo-600 px-6 py-5">
                  <span className="text-xs font-semibold uppercase tracking-widest text-indigo-200">
                    {t("Como nos encontrar")}
                  </span>
                  <h2 className="text-lg font-bold text-white mt-1">
                    {t("Informações de Contacto")}
                  </h2>
                </div>

                <div className="divide-y divide-gray-100">
                  {contactInfo.map((c) => (
                    <div
                      key={c.label}
                      className="flex items-start gap-4 px-6 py-4 hover:bg-gray-50 transition-colors"
                    >
                      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600">
                        {c.icon}
                      </div>

                      <div>
                        <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-0.5">
                          {c.label}
                        </p>

                        {c.href ? (
                          <a
                            href={c.href}
                            target={c.href.startsWith("http") ? "_blank" : undefined}
                            rel="noreferrer"
                            className="text-sm font-medium text-gray-800 hover:text-indigo-600 transition-colors whitespace-pre-line"
                          >
                            {c.value}
                          </a>
                        ) : (
                          <p className="text-sm font-medium text-gray-800 whitespace-pre-line">
                            {c.value}
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="rounded-3xl border border-gray-200 overflow-hidden shadow-md">
                <iframe
                  title={t("Localização RacksForAll")}
                  src="https://www.openstreetmap.org/export/embed.html?bbox=-8.8300%2C39.6500%2C-8.8000%2C39.6700&layer=mapnik&marker=39.6600%2C-8.8150"
                  className="w-full h-64"
                  loading="lazy"
                />
                <div className="px-5 py-3 bg-gray-50 border-t border-gray-200 flex items-center justify-between">
                  <p className="text-xs text-gray-500">{t("Batalha, Portugal")}</p>
                  <a
                    href="https://maps.google.com/?q=Estrada+Nacional+1+Batalha+Portugal"
                    target="_blank"
                    rel="noreferrer"
                    className="text-xs font-semibold text-indigo-600 hover:text-indigo-800 transition-colors"
                  >
                    {t("Obter Direções →")}
                  </a>
                </div>
              </div>
            </div>

            <div className="h-full min-h-[560px] rounded-3xl border border-gray-200 bg-white shadow-md overflow-hidden">
              <div className="bg-indigo-600 px-6 py-5">
                <span className="text-xs font-semibold uppercase tracking-widest text-indigo-200">
                  {t("Formulário")}
                </span>
                <h2 className="text-lg font-bold text-white mt-1">
                  {t("Envie-nos uma Mensagem")}
                </h2>
              </div>

              <div className="px-6 sm:px-8 py-8 h-full">
                {sent ? (
                  <div className="flex h-full min-h-[420px] flex-col items-center justify-center text-center gap-4">
                    <div className="flex h-16 w-16 items-center justify-center rounded-full bg-indigo-50">
                      <svg
                        className="w-8 h-8 text-indigo-600"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>

                    <h3 className="text-lg font-semibold text-gray-900">
                      {t("Mensagem enviada!")}
                    </h3>
                    <p className="text-sm text-gray-500 max-w-xs">
                      {t("Entraremos em contacto consigo em breve.")}
                    </p>

                    <button
                      onClick={() => {
                        setSent(false);
                        setErrorMsg("");
                      }}
                      className="mt-2 text-sm font-semibold text-indigo-600 hover:text-indigo-800 transition-colors"
                    >
                      {t("Enviar outra mensagem")}
                    </button>
                  </div>
                ) : (
                  <>
                    {errorMsg && (
                      <div className="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                        {errorMsg}
                      </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-4 h-full">
                      <div className="grid sm:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                            {t("Primeiro Nome *")}
                          </label>
                          <input
                            name="firstName"
                            value={form.firstName}
                            onChange={handleChange}
                            placeholder="João"
                            required
                            className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent focus:bg-white transition-colors"
                          />
                        </div>

                        <div>
                          <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                            {t("Último Nome *")}
                          </label>
                          <input
                            name="lastName"
                            value={form.lastName}
                            onChange={handleChange}
                            placeholder="Silva"
                            required
                            className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent focus:bg-white transition-colors"
                          />
                        </div>
                      </div>

                      <div>
                        <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                          {t("Email *")}
                        </label>
                        <input
                          type="email"
                          name="email"
                          value={form.email}
                          onChange={handleChange}
                          placeholder="joao.silva@empresa.pt"
                          required
                          className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent focus:bg-white transition-colors"
                        />
                      </div>

                      <div>
                        <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                          Empresa *
                        </label>
                        <input
                          name="empresa"
                          value={form.empresa}
                          onChange={handleChange}
                          placeholder="Nome da Sua Empresa"
                          required
                          className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent focus:bg-white transition-colors"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          {t("Motivo de contacto")}
                        </label>
                        <div className="relative">
                          <select
                            name="motivo"
                            value={form.motivo}
                            onChange={handleChange}
                            className="w-full appearance-none rounded-xl border border-gray-200 bg-white px-4 py-2.5 pr-10 text-sm text-gray-700 shadow-sm outline-none transition focus:border-gray-400 focus:ring-4 focus:ring-gray-100"
                          >
                            <option value="">{t("Selecione um motivo")}</option>
                            <option value="Devoluções">{t("Devoluções")}</option>
                            <option value="Pedido de Contacto Comercial">{t("Pedido de Contacto Comercial")}</option>
                            <option value="Esclarecimentos pós-venda">{t("Esclarecimentos pós-venda")}</option>
                            <option value="Outros Assuntos">{t("Outros Assuntos")}</option>
                          </select>
                          <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="m6 9 6 6 6-6" />
                            </svg>
                          </span>
                        </div>
                      </div>

                      <div>
                        <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                          {t("Telefone *")}
                        </label>
                        <div className="flex gap-2">
                          <div className="flex items-center gap-1.5 rounded-xl border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm text-gray-700 shrink-0">
                            <span>🇵🇹</span>
                            <span>+351</span>
                          </div>
                          <input
                            name="telefone"
                            value={form.telefone}
                            onChange={handleChange}
                            placeholder="913 650 724"
                            required
                            className="flex-1 rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent focus:bg-white transition-colors"
                          />
                        </div>
                      </div>

                      <div>
                        <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                          {t("Mensagem *")}
                        </label>
                        <textarea
                          name="mensagem"
                          value={form.mensagem}
                          onChange={handleChange}
                          placeholder={t("Conte-nos sobre as suas necessidades de armazenamento...")}
                          required
                          rows={5}
                          className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent focus:bg-white transition-colors resize-none"
                        />
                      </div>

                      <button
                        type="submit"
                        disabled={sending}
                        className="w-full flex items-center justify-center gap-2 rounded-xl bg-indigo-600 px-6 py-3 text-sm font-semibold text-white hover:bg-indigo-700 shadow-sm transition-all disabled:opacity-60 disabled:cursor-not-allowed"
                      >
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
                          />
                        </svg>
                        {sending ? t("A enviar...") : t("Enviar Mensagem")}
                      </button>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}